import { gql } from "@apollo/client";

import { CAMPAIGN_FIELDS_FOR_TEXTER } from "./campaigns";
import { THREAD_ACTION_FIELDS } from "./threadAction";

export const REQUEST_ASSIGNMENT_BATCH = gql`
  mutation requestAssignmentBatch($input: RequestAssignmentBatchInput!) {
    requestAssignmentBatch(input: $input) {
      success
    }
  }
`;

export const RELEASE_ASSIGNMENTS = gql`
  mutation releaseAssignments($input: ReleaseAssignmentsInput!) {
    releaseAssignments(input: $input) {
      success
    }
  }
`;

export const LIST_ASSIGNMENTS = gql`
  query listAssignments($input: ListMyAssignmentsInput!) {
    listMyAssignments(input: $input) {
      totalCount
      assignments {
        id
        expiresAt
        contactFirstName
        contactLastName
        fromPhoneNumber
        toPhoneNumber
        needsTexterResponse
        lastMessageAt
        campaignName
      }
    }
  }
`;

export const ASSIGNMENT_FIELDS = gql`
  ${CAMPAIGN_FIELDS_FOR_TEXTER}
  ${THREAD_ACTION_FIELDS}
  ${CAMPAIGN_FIELDS_FOR_TEXTER}
  fragment AssignmentFields on Assignment {
    id
    expiresAt
    threadId
    campaignContact {
      id
    }
    campaign {
      ...CampaignFieldsForTexter
    }
    contactFirstName
    contactLastName
    needsTexterResponse
    lastMessageAt
    mostRecentMessageIsFromOtherCampaign
    messages {
      direction
      id
      mediaAttachments {
        mimeType
        url
      }
      messageType
      provider
      providerErrorCode
      providerId
      segments
      status
      text
      threadOrderTime
      campaignId
      campaignShortId
      campaignName
      campaignContactId
      createdByUserId
      createdByUserFullName
      isInitialOutboundForCampaign
      shortenedLinks {
        shortUrl
        targetUrl
      }
    }
    threadActions {
      ... on ThreadAction {
        ...ThreadActionFields
      }
      ... on ApplyCampaignTagsThreadAction {
        ...ThreadActionFields
        actionData {
          tags {
            id
            name
          }
        }
      }
      ... on RemoveCampaignTagsThreadAction {
        ...ThreadActionFields
        actionData {
          tags {
            id
            name
          }
        }
      }
      ... on EscalateThreadAction {
        ...ThreadActionFields
        actionData {
          escalationInbox {
            id
            name
          }
        }
      }
      ... on DeescalateThreadAction {
        ...ThreadActionFields
        actionData {
          escalationInbox {
            id
            name
          }
        }
      }
      ... on MoveEscalationThreadAction {
        ...ThreadActionFields
        actionData {
          fromEscalationInbox {
            id
            name
          }
          toEscalationInbox {
            id
            name
          }
        }
      }
      ... on MoveInboxThreadAction {
        ...ThreadActionFields
        actionData {
          fromInbox {
            id
            name
          }
          toInbox {
            id
            name
          }
        }
      }
    }
    fromOwnedPhoneNumber {
      id
      shortCodeConfig {
        optInMessage
        optOutMessage
      }
      messageClass
    }
    subaccount {
      textingHoursEnd
      textingHoursStart
      textingHoursTimezone
    }
  }
`;

export const GET_ASSIGNMENTS = gql`
  ${ASSIGNMENT_FIELDS}
  query getAssignments($input: GetAssignmentsInput!) {
    getAssignments(input: $input) {
      ...AssignmentFields
    }
  }
`;

export const EXTEND_ASSIGNMENT = gql`
  mutation extendAssignment($input: ExtendAssignmentInput!) {
    extendAssignment(input: $input) {
      success
    }
  }
`;

export const SEND_MESSAGE_TO_ASSIGNMENT = gql`
  ${ASSIGNMENT_FIELDS}
  mutation sendMessageToAssignment($input: SendMessageToAssignmentInput!) {
    sendMessageToAssignment(input: $input) {
      ...AssignmentFields
    }
  }
`;

export const MARK_ASSIGNMENT_OPTED_OUT = gql`
  mutation markAssignmentOptedOut($input: MarkAssignmentOptedOutInput!) {
    markAssignmentOptedOut(input: $input) {
      id
    }
  }
`;

export const MARK_ASSIGNMENT_NEEDS_RESPONSE = gql`
  ${ASSIGNMENT_FIELDS}
  mutation markAssignmentNeedsResponse(
    $input: MarkAssignmentNeedsResponseInput!
  ) {
    markAssignmentNeedsResponse(input: $input) {
      ...AssignmentFields
    }
  }
`;

export const MARK_ASSIGNMENT_NOT_NEEDS_RESPONSE = gql`
  ${ASSIGNMENT_FIELDS}
  mutation markAssignmentNotNeedsResponse(
    $input: MarkAssignmentNotNeedsResponseInput!
  ) {
    markAssignmentNotNeedsResponse(input: $input) {
      ...AssignmentFields
    }
  }
`;

export const UPDATE_ASSIGNMENT_CONTACT_TAGS = gql`
  ${ASSIGNMENT_FIELDS}
  mutation updateAssignmentContactTags(
    $input: UpdateAssignmentContactTagsInput!
  ) {
    updateAssignmentContactTags(input: $input) {
      ...AssignmentFields
    }
  }
`;

export const SET_ASSIGNMENT_CONTACT_NOTE = gql`
  ${ASSIGNMENT_FIELDS}
  mutation setAssignmentContactNote($input: SetAssignmentContactNoteInput!) {
    setAssignmentContactNote(input: $input) {
      ...AssignmentFields
    }
  }
`;

export const ESCALATE_ASSIGNMENT = gql`
  mutation escalateAssignment($input: EscalateAssignmentInput!) {
    escalateAssignment(input: $input) {
      success
    }
  }
`;

export const DEESCALATE_ASSIGNMENT = gql`
  mutation deescalateAssignment($input: DeescalateAssignmentInput!) {
    deescalateAssignment(input: $input) {
      success
    }
  }
`;
